module.exports = __webpack_public_path__ + "32d4589bd4c760fcc3ac432a62d6f856.pdf";